import api from 'services/api';
import { type Received } from 'validation';

import { readResponse } from 'api/shared/readResponse';

import { zoneSchema, type SaveZone, type Zone } from './postZone';

/**
 * PUT `/zones/:name` — update the zone identified by `originalName` (its
 * pre-edit name). The body's `name` is sent as the wire's `new_name` (a rename),
 * so callers pass the same `SaveZone` they'd give `postZone`. Returns the updated
 * zone (validated against the shared `zoneSchema` — same `getZoneDetails` shape
 * as create).
 * Rejects on HTTP error — the write did not happen, and the server's complaint
 * is the useful thing to report. Answers with the **unreadable** arm when the
 * write DID happen and its receipt cannot be read: by then the server has
 * committed, so that is not a failed save and must not be reported as one
 * (#1035).
 */
export const putZone = async (originalName: string, save: SaveZone): Promise<Received<Zone>> => {
  const res = await api.put(`/zones/${encodeURIComponent(originalName)}`, {
    new_name: save.name,
    description: save.description,
    retention_policies: save.retention_policies,
  });
  return readResponse(res.data, { schema: zoneSchema, source: 'putZone' });
};
